export default __webpack_public_path__ + "static/media/slide2.d99f4d90.jpg";